module.exports = __webpack_public_path__ + "img/invite_coupon_used.947cb8eb.jpg";